import {FilterCategory, FilterCategoryType, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {FilterDropdown} from "@/components/filterDropdown/FilterDropdown.tsx";
import {GQL_MONITORING_SERVER_FILTER_DATA_LOCATIONS} from "@/lib/queries/monitoring.ts";

type MonitoringServersFiltersProps = {
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
};

export const MonitoringServersFilters = ({filterSets, onFilterSetChange}: MonitoringServersFiltersProps) => {
  const filterFields: FilterCategory[] = [
    {
      key: "continents",
      type: FilterCategoryType.ARRAY,
      display: "Regions",
      options: [
        {key: "NA", display: "North America"},
        {key: "SA", display: "South America"},
        {key: "EU", display: "Europe"},
        {key: "AF", display: "Africa"},
        {key: "AS", display: "Asia"},
        {key: "OC", display: "Oceania"},
      ],
      sorted: true,
    },
    {
      key: "locations",
      type: FilterCategoryType.GQL,
      display: "Location",
      graphql: GQL_MONITORING_SERVER_FILTER_DATA_LOCATIONS,
      sorted: true,
    },
    {
      key: "monitoring_level",
      type: FilterCategoryType.ARRAY,
      display: "Tier",
      options: [
        {key: "LEVEL_0|LEVEL_1", display: "Starter"},
        {key: "LEVEL_2", display: "Essential"},
        {key: "LEVEL_3", display: "Premium"},
      ],
      sorted: true,
    },
  ];

  return <FilterDropdown categories={filterFields} appliedFilterSets={filterSets} onApply={onFilterSetChange} />;
};
